import { ReactComponent as GoogleStore } from "assets/social/google-store.svg";
import qr from "assets/social/qr-code.png";
import { LINKS } from "utils/constants";
import "./googlePlay.scss";

const GooglePlay = () => {
  return (
    <>
      <a href={LINKS.PLAYSTORE} target="_blank" rel="noreferrer" className="google-play-link">
        <GoogleStore />
      </a>
      <img src={qr} alt="qr-code" className="google-play-qr-code" />
    </>
  );
};

export default GooglePlay;
